import { useEffect, useState } from "react";
import api from "../../api/client";

export default function OrgSiteAssignments() {
  const [orgs, setOrgs] = useState([]);
  const [sites, setSites] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState("");
  const [assignedSiteIds, setAssignedSiteIds] = useState(new Set());
  const [message, setMessage] = useState("");

  const load = async () => {
    const [orgResp, siteResp] = await Promise.all([api.get("/admin/organizations/"), api.get("/sites")]);
    setOrgs(orgResp.data);
    setSites(siteResp.data);
  };

  useEffect(() => {
    load().catch(() => setMessage("Failed to load organizations/sites"));
  }, []);

  const loadAssignments = async (orgId) => {
    if (!orgId) return;
    const resp = await api.get(`/admin/orgs/${orgId}/sites`);
    setAssignedSiteIds(new Set(resp.data.map((s) => s.site_id)));
  };

  useEffect(() => {
    if (selectedOrg) {
      loadAssignments(selectedOrg).catch(() => setMessage("Failed to load org sites"));
    } else {
      setAssignedSiteIds(new Set());
    }
  }, [selectedOrg]);

  const toggleSite = (siteId) => {
    setAssignedSiteIds((prev) => {
      const next = new Set(prev);
      if (next.has(siteId)) next.delete(siteId);
      else next.add(siteId);
      return next;
    });
  };

  const save = async () => {
    if (!selectedOrg) return;
    setMessage("");
    try {
      await api.post(`/admin/orgs/${selectedOrg}/sites`, {
        site_ids: Array.from(assignedSiteIds),
      });
      setMessage("Saved");
    } catch (err) {
      setMessage(err?.response?.data?.detail || "Save failed");
    }
  };

  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold text-slate-900">Organization → Sites</h1>
      <div className="flex gap-3 items-center">
        <label className="text-sm text-slate-700">Organization:</label>
        <select
          className="rounded border px-2 py-2"
          value={selectedOrg}
          onChange={(e) => setSelectedOrg(e.target.value)}
        >
          <option value="">Select</option>
          {orgs.map((o) => (
            <option key={o.id} value={o.id}>
              {o.company_name}
            </option>
          ))}
        </select>
        <button
          onClick={save}
          className="ml-auto px-4 py-2 bg-slate-900 text-white rounded disabled:opacity-60"
          disabled={!selectedOrg}
        >
          Save
        </button>
      </div>
      {message && <div className="text-sm text-slate-600">{message}</div>}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {sites.map((s) => (
          <label key={s.id} className="flex items-center gap-2 border rounded px-3 py-2 bg-white shadow-sm">
            <input
              type="checkbox"
              checked={assignedSiteIds.has(s.id)}
              onChange={() => toggleSite(s.id)}
              disabled={!selectedOrg}
            />
            <span className="text-sm text-slate-800">{s.name}</span>
          </label>
        ))}
      </div>
      {sites.length === 0 && <div className="text-sm text-slate-500">No sites available.</div>}
    </div>
  );
}
